import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import type {
  ReportDashboardLibraryComponent,
  ReportDashboardLibraryApiResponse,
} from '@core/reports-types';

import { SharedAnalyticsReportsHttpApiService } from '../../services/reports-http-api.service';

@Injectable({ providedIn: 'root' })
export class ReportsLibraryComponentsHttpClient {
  private readonly httpApi = injectReportsHttpApiService();

  public fetchCollection(): Observable<{ componentTemplates: ReportDashboardLibraryComponent[] }> {
    const endpoint = this.isSharedAnalytics()
      ? '/templates/components'
      : '/report/component_templates';
    return this.httpApi.get<ReportDashboardLibraryApiResponse>(endpoint);
  }

  private isSharedAnalytics(): boolean {
    return this.httpApi instanceof SharedAnalyticsReportsHttpApiService;
  }
}
